/**
 * Created by danielda on 6/16/2015.
 */

define(function (require) {
   "use strict";

    var LE = require("app");
    var CONST = require("const");
    var RevisionedCollection = require("collections/RevisionedCollection");
    var ApiResources = require("assets/data/apiResources.json");
    var AgentGroupModel = require("user-management-models/AgentGroupModel");
    var LEResourceResolver = require("leResourceResolver");

    var NAME = "AgentGroupsCollection";

    var AgentGroupsCollection = {};
    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        AgentGroupsCollection = RevisionedCollection.extend({
            model: AgentGroupModel,
            name: NAME,
            resource: ApiResources.AccountConfig.AgentGroups,

            url: function() {
                return LEResourceResolver.getUrl.call(this, ApiResources.AccountConfig.AgentGroups) + "&select=$all";
            },

            initialize: function(models, options) {
                options = options || {};
                RevisionedCollection.prototype.initialize.call(this,models,options);
            },

            updateSubGroups: function() {
                this.each(function(model) {
                    model.resetSubGroups();
                });
                this.each(_.bind(function(model) {
                    var parentGroupId = model.getParentGroupId();
                    var parentGroupModel = this.get(parentGroupId);
                    if (parentGroupModel) {
                        parentGroupModel.addSubGroup(model.id);
                    }
                }, this));
            },

            fetch: function(options) {
                options = options ? _.clone(options) : {};
                if (options.fetchOptions && options.fetchOptions.data) {
                    options.data = options.fetchOptions.data;
                }

                var origSuccess = options.success;
                var origError = options.error;

                options.success = _.bind(function(collection, resp, opt) {
                    this.updateSubGroups();
                    if (origSuccess) {
                        origSuccess(collection, resp, options);
                    }
                }, this);

                RevisionedCollection.prototype.fetch.call(this, options);
            },

            getMainGroup: function() {
                var mainGroupFilterObj = {};
                mainGroupFilterObj[this.model.KEYS.PARENT_GROUP_ID] = null;
                return this.findWhere(mainGroupFilterObj);
            },

            isCollectionAllowed: function() {
                return CONST.SOURCE_ENUM.LE === LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.USERS_SOURCE);
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    AgentGroupsCollection.NAME = NAME;

    return AgentGroupsCollection;
});

